/* eslint-disable i18next/no-literal-string */
export default function FleetTrips() {
  return (
    <div className="p-12">
      <h1 className="text-2xl font-bold">Trip History</h1>
    </div>
  );
}
